const lang = {
    "Kep": "QES",
    "KepNotLinked": "החתימה המאושרת שלך עדיין לא מקושרת לחשבון. היכנס/י כרגיל ואנחנו נקשר אותה.",
    "KepNewAccount": "אין לך חשבון? הרשמה",
    "KepLinked": "החתימה המאושרת קושרה לחשבון",
    "KepLinkFailed": "לא ניתן לקשר את החתימה המאושרת. היכנס/י איתה שוב ואנחנו נקשר אותה",
    "KepFile": "קובץ מפתח",
    "ErrorKepLogin": "הכניסה עם חתימה מאושרת נכשלה",
    "EnterWidth": "כניסה דרך:",
    "Registration": "הירשם",
    "enter": "להיכנס",
    "EntrWidthEmailOrPhone": "התחברות באמצעות דואל או טלפון",
    "login": "הַרשָׁאָה",
    "NoAkkGoReg": "לִרְשׁוֹם",
    "Password": "סיסמה",
    "Name": "שֵׁם",
    "LastName": "שֵׁם מִשׁפָּחָה",
    "Phone": "להרשמה, הזינו את מספר הטלפון שלכם",
    "Email": "דוֹאַר",
    "RepeatPassword": "חזור על הסיסמה",
    "Сancel": "לְבַטֵל",
    "Save": "להציל",
    "Language": "שפה",
    "ConfirmThisMail": "האימייל שלך אושר",
    "Saved": "שמור",
    "Error": "שְׁגִיאָה",
    "FillInAllTheFields": "מלא את כל השדות",
    "Next": "נוסף",
    "MinPassLength": "אורך סיסמה מינימלי 4 תווים",
    "ForgotYourPassword": "שכחת ססמה",
    "RestorePassword": "אנא הגדר סיסמה חדשה.",
    "UserMustBeRegistered": "המשתמש חייב להיות רשום",
    "Confirm": "לְאַשֵׁר",
    "WrongFormat": "פורמט שגוי",
    "WrongPassword": "סיסמא לא נכונה",
    "WrongLoginOrPassword": "שם משתמש או סיסמא שגויים",
    "PhoneAlreadyRegistered": "הטלפון כבר רשום",
    "EmailAlreadyRegistered": "הדואר כבר רשום",
    "FillInTheFieldsCorrectly": "מלא את השדות בצורה נכונה",
    "ThisAccountDoesNotExist": "החשבון הזה אינו קיים",
    "LinkIsNotValid": "הקישור אינו תקף",
    "AMessageHasBeenSentToTheSpecifiedLogin": "הודעה נשלחה לכניסה שצוינה",
    "IncorrectCaptcha": "טעות בקאפצ'ה",
    "CaptchaIsNotValid": "Captcha כבר לא תקף",
    "EnterCaptcha": "הזן captcha",
    "EnterSMS": "הזן את הקוד מ-SMS",
    "SMSCodeIsNoLongerValid": "קוד ה-SMS אינו תקף יותר",
    "SMSCodeIsIncorrect": "קוד SMS שגוי",
    "MailNotVerifiedLinkTimedOut": "האימייל לא אושר, זמן הקישור פג",
    "DemoLogin": "כניסה להדגמה",
    "AreYouSureYouWantToEnterTheDemoForEvaluation": "האם אתה בטוח שאתה רוצה להיכנס לגרסת הניסיון?",
    "FillInAdditionalInformation": "מלא מידע נוסף",
    "ToCompleteRegistration": "להשלמת הרישום",
    "LinkThirdPartyServices": "קישור שירותי צד שלישי",
    "Complete": "לְהַשְׁלִים",
    "AccountAlreadyLinked": "החשבון כבר מקושר",
    "AccountNotRegistered": "חשבון לא רשום",
    "NotMyNumber": "לא המספר שלי",
    "Back": "חזור",
    "numberOfAttemptsToCheckAuth": "מספר ניסיונות התחברות:",
    "InvalidPassNumberOfAttemptsToCheckAuth": "סיסמה שגויה, מספר ניסיונות התחברות:",
    "TryAgainAfterMinute": "אנא נסה שוב בעוד 2 דקות",
    "Help": "תמיכה טכנית",
    "y": "כן",
    "n": "לא",
    "doYouConfirmEmail": "האם אתה בטוח שברצונך לשנות את האימייל שלך?",
    "success": "בְּהַצלָחָה",
    "goToAutorize": "עבור אל הרשאה",
    "UserEmailAlreadyExists": "משתמש עם אימייל זה כבר קיים",
    "UserPhoneAlreadyExists": "כבר קיים משתמש עם אותו מספר טלפון",
    "TermOfUse": "תנאי שימוש",
    "PrivacyPolicy": "מדיניות הפרטיות",
    "accountNotRegistered": "חשבון לא רשום",
    "wantToReg": "האם תרצה להירשם?",
    "weSuccessChangeYouEmail": "שינינו בהצלחה את כתובת הדואל שלך",
    "youCanCloseThisWindow": "אתה יכול לסגור את החלון הזה",
    "countryConfirm": "אישור מדינה",
    "EmailAlreadyTied": "הדואר כבר מקושר לחשבון אחר",
    "areYourCountry": "זו המדינה שלך?",
    "EmergencyEntrance": "אישור ישן",
    "enterCorrectNumber": "הזן את המספר בפורמט בינלאומי",
    "thisPhoneRegister": "מספר הטלפון הזה כבר רשום במערכת",
    "wantUsePhoneForAuth": "האם תרצה להתחבר באמצעות מספר הטלפון הזה?",
    "ok": "בסדר",
    "regAgree": "על ידי רישום חשבון, אני מסכים",
    "wantBind": "האם אתה רוצה להיכנס לחשבון שלך ולקשר את השירות?",
    "bind": "לְצַלֵם",
    "yoursMailBinded": "האימייל שלך רשום בחשבון קיים",
    "wantUsePhoneAndBind": "כבר רשום במערכת",
    "notGetDataFromApple": "קבלת הנתונים מאפל נכשלה",
    "ErrorAppleLogin": "שגיאה בהרשאה דרך אפל",
    "ErrorGoogleLogin": "שגיאה בהרשאה דרך Google",
    "ErrorTelegramLogin": "שגיאה בעת הכניסה דרך טלגרם",
    "ErrorFacebookLogin": "שגיאה בכניסה דרך פייסבוק",
    "EMailOrPhone": "נא להזין מספר טלפון או כתובת אימייל חוקיים.",
    "withoutName": "אין שם",
    "goToCabinet": "למשרד",
    "Logout": "סיום הפגישה",
    "creationDate": "תאריך היצירה",
    "preparingCompany1": "אנחנו יוצרים את החברה שלך, בבקשה תן לנו דקה...",
    "preparingCompany2": "אנו מכינים ממשק לניהול סחורות ושירותים...",
    "preparingCompany3": "אנו עובדים על חשבונאות פיננסית נוחה...",
    "preparingCompany4": "אנחנו עושים הגדרות סופיות, כמעט מוכנות...",
    "companyBlocked": "חברה זו אינה פעילה",
    "youBlockedInComp": "המשתמש אינו פעיל, לא ניתן להתחבר",
    "loginTitle": "כל מה שעסק צריך במקום אחד",
    "loginDescr": "אוטומציה לחנויות, בתי קפה, שירותי משלוחים, מסעדות, מחסנים, ייצור או שירותים",
    "NoAkkGoRegText": "אין לך חשבון?",
    "LoginPlaceholder": "אנא ספקו את המידע הנדרש",
    "loginText": "כבר יש לך חשבון?",
    "and": "ו",
    "AcceptTheTerms": "אנא אשרו את מדיניות הפרטיות ותנאי השימוש",
    "CountryPhoneFormat": "אם זו אינה המדינה שלך, אנא ודא שהזנת את מספר הטלפון שלך בפורמט הבינלאומי הנכון.",
    "SaveNewPassword": "שמור סיסמה חדשה"
}

export default function() {
    return lang;
}